import { Component, OnInit } from '@angular/core';
import { FooterLinkColumns } from '@shared/interfaces/footer-link-columns.interface';
import { BaseComponent } from '@shared/components/base.component';
import { Config } from '@shared/config';
import { NavigationEnd, Router } from '@angular/router';
import { Tag } from '@shared/interfaces/project/tag.interface';
import { ProjectsService } from '@layouts/default/layouts/guest/pages/projects/projects.service';
import { BehaviorSubject } from 'rxjs';
import { FooterContentService } from '@shared/services/footer-content.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent extends BaseComponent implements OnInit {
  Config: any = Config;
  eventCategory = new BehaviorSubject(false);
  columns: FooterLinkColumns[];

  constructor(
    public projects: ProjectsService,
    public footerContent: FooterContentService,
    public router: Router
  ) {
    super();
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.columns = this.footerContent.loadFooterContent();
      }
    });
  }

  ngOnInit() {
    this.getProject();
  }

  scrollTop() {
    const element = document.body;
    const duration = 500;
    const startingY = window.pageYOffset;
    const elementY = window.pageYOffset + element.getBoundingClientRect().top - 100;
    const targetY =
      document.body.scrollHeight - elementY < window.innerHeight
        ? document.body.scrollHeight - window.innerHeight
        : elementY;
    const diff = targetY - startingY;
    const easing = (t) => {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    };

    let start;
    if (!diff) {
      return;
    }
    window.requestAnimationFrame(function step(timestamp) {
      if (!start) {
        start = timestamp;
      }
      const time = timestamp - start;
      let percent = Math.min(time / duration, 1);
      percent = easing(percent);
      window.scrollTo(0, startingY + diff * percent);
      if (time < duration) {
        window.requestAnimationFrame(step);
      }
    });
  }

  getProject() {
    const ukrainianCategories = Config.UKRAINE_CATEGORY.split(',').map(Number);

    this.router.events.subscribe((val) => {
      const projectId = this.router.url.match(/(\d+)/);
      if (
        val instanceof NavigationEnd &&
        projectId !== null &&
        this.router.url.indexOf('/projects/verified/' + projectId[0]) > -1
      ) {
        const subTags = this.projects.currentProjectCategories$
            .subscribe((categories: Tag[]) => {
              this.eventCategory.next(categories ? categories.filter(
                  (cat) => ukrainianCategories.includes(cat.id)
              ).length > 0 : false);
          });
        this.someSubscriptions.add(subTags);
      } else {
        this.eventCategory.next(false);
      }
    });
  }
}
